import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { StyledFontAwesomeIcon } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function DO_NOT_USE_FaWrapper(props) {
  return /*#__PURE__*/jsx(StyledFontAwesomeIcon, _extends({
    "data-icon": "falcon"
  }, props));
}

export { DO_NOT_USE_FaWrapper };
